<template>
  <!-- 关于我们 -->
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span>首页</span>
        <span>></span>
        <span>关于我们</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="privacy">
            <p>关于我们</p>
            <div>世界纷繁，读点儿好的</div>
            <div>
              2008年，《第一财经周刊》诞生。它是中国首家每周出版的商业新闻杂志，以轻松、有用、时尚的报道服务广大公司人群。作为市场化商业思维的推动者，《第一财经周刊》从商业信息、商业逻辑到生活方式、价值观，全方位影响读者，堪称新一代知识青年必读的商业读本。
            </div>
            <div>
              2019年，《第一财经周刊》转型升级为月刊
              ——《第一财经》杂志YiMagazine，更侧重于大型的、多元维度的重磅报道策划，以及数据的可视化呈现。这本杂志比书籍更丰富，比杂志更深度——可以说原创了一种新型的阅读产品，解决因为互联网资讯繁荣给出版物带来的时效性桎梏，沉淀下那些真正需要探讨的问题。变化的，是更深度的内容和更丰富的阅读体验；坚持不变的，是“探索明亮的商业世界”的价值观，和对新的、有趣的传播形式的探索。
            </div>
            <div>
              现在，你可以通过App和网站随时随地看到、听到我们的内容。《第一财经》杂志App、cbnweek.com整合了杂志制作中心所有的数字化阅读、课程&音频节目内容，并实现网站与iPad、iPhone和Android平台多个移动媒体应用内容及用户数据对接。
            </div>
            <div>
              同时，我们也开创了“订阅新世代”——如果你在有赞“第一财经小店”内购买订阅码，通过《第一财经》杂志App或cbnweek.com激活订阅码，即可开启数字杂志订阅。订阅码的好处是可以分发或转送他人，尤其适合公司、学校“团购”使用。
            </div>
            <div>
              订阅《第一财经》杂志，App
              Store不再是用户唯一通路。无论PC、手机、iPad或其他终端设备，通过支付宝或快捷支付即能实现订阅。一码/一账户在手，所有终端均可同步。
            </div>
          </div>
        </div>
        <div class="content-r">
          <Wechart></Wechart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wechart from "@/components/wechart";
import { getTdkList} from "@/api/tdk";
export default {
  components: {
    Wechart
  },
  data() {
    return {};
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  span:last-child {
    color: #0091ff;
  }
}
.privacy {
  padding: 30px;
  background: #ffffff;
  margin-bottom: 60px;
  text-align: justify;
  p {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  div {
    font-size: 18px;
    line-height: 36px;
    margin-bottom: 40px;
  }
  div:last-child {
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/footer/about.vue